import React, { useState, useEffect, useMemo } from 'react';

interface EventSlide {
  title: string;
  description: string;
  meta: string;
  date: string;
  cta: string;
  eventcode: string;
  backgroundBanner?: {
    imageUrl?: string;
  };
}

const defaultEvents: EventSlide[] = [
  
];

interface EventCarouselProps {
  events?: any[];
}

const EventCarousel: React.FC<EventCarouselProps> = ({ events = [] }) => {
  const eventsToShow: EventSlide[] = useMemo(() => events.length > 0
    ? events.map(event => {
        let cta = 'Coming Soon';
        if (event.status === 'REGISTRATIONSCLOSED') {
          cta = 'Registrations Closed';
        } else if (event.status === 'REGISTRATIONSOPEN') {
          cta = 'Register Now';
        } else if (event.status === 'OPEN') {
          cta = 'Coming Soon';
        }
        return {
          title: event.name || 'Event',
          description: event.additionalFields?.description || 'Join us for this exciting event.',
          meta: `📍 ${event.venuename || event.city || 'Location TBA'} • ${new Date(event.startdate).toLocaleDateString()}`,
          date: event.startdate || new Date().toISOString(),
          cta: cta,
          eventcode: event.eventcode || '',
          backgroundBanner: event.backgroundBanner || {}
        };
      })
    : defaultEvents, [events]);

  const [currentIndex, setCurrentIndex] = useState(0);
  const [timers, setTimers] = useState<string[]>([]);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % eventsToShow.length);
    }, 8000);
    return () => clearInterval(interval);
  }, [eventsToShow.length]);

  useEffect(() => {
    const updateTimers = () => {
      const newTimers = eventsToShow.map(event => {
        const targetDate = new Date(event.date).getTime();
        const now = new Date().getTime();
        const diff = targetDate - now;

        if (diff <= 0) {
          return 'Event is live now!';
        }

        const days = Math.floor(diff / (1000 * 60 * 60 * 24));
        const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const minutes = Math.floor((diff / (1000 * 60)) % 60);
        const seconds = Math.floor((diff / 1000) % 60);

        return `<div><span>${days}</span>Days</div><div><span>${hours}</span>Hrs</div><div><span>${minutes}</span>Min</div><div><span>${seconds}</span>Sec</div>`;
      });
      setTimers(newTimers);
    };

    updateTimers();
    const interval = setInterval(updateTimers, 1000);
    return () => clearInterval(interval);
  }, [eventsToShow]);

  const handleIndicatorClick = (index: number) => {
    setCurrentIndex(index);
  };

  const currentEvent = eventsToShow[currentIndex];
  
  return (
    <>
    <style>
      {`
      .caption-bottom{
        position: absolute;
        left: 0;
        right: 0;
        bottom: 20px;
        z-index: 5;
        width: 100%;
        pointer-events: none;
      }

        .carousel-caption {
        color: #000;
        font-size: 1.3em;
        margin: 0 !important;
        min-height: 5em;
        padding: 12px 0 12px 100px;
        position: relative;
        text-align: left;
        width: 100%;
        box-sizing: border-box;
        background: rgba(255, 255, 255, .8);
        z-index: 1;
        left: 0;
        right: 0;
      }
        
        .carousel-caption h2 {
        font-size: 20px !important;
        line-height: 1.1;
        margin-bottom: 0.2em;
        }

      /* Caption content styles */
      .caption-content {
      position: absolute;
      right: 15px;
      bottom: -5px;
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 10px;
      max-width: min(420px, calc(100% - 80px));
      pointer-events: auto;
      }

      .register-btn-left {
      position: absolute;
      left: 15px;
      bottom: -5px;
      pointer-events: auto;
      }

      .agenda-btn-atp {
      position: absolute;
      right: 100px;
      bottom: 100px;
      pointer-events: auto;
      }

      .sponsor-btn-left {
      position: absolute;
      left: 40px;
      bottom: 100px;
      max-width: calc(100% - 40px);
      pointer-events: auto;
      display: flex;
      align-items: center;
      gap: 14px;
      }

      .sponsor-btn-left a {
      display: inline-flex;
      align-items: center;
      }
      
      .sponsor-btn-left .event-cta {
      min-width: 120px;
      height: 44px;
      padding: 10px 18px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      white-space: nowrap;
      }

      .Agenda-btn-left {
      position: static;
      margin-left: 20px;
      pointer-events: auto;
      }

      /* Event carousel responsive styles */
      .event-carousel {
        position: relative;
        width: 100%;
        margin: 0 !important;
        padding: 0 !important;
        aspect-ratio: 16 / 9;
        background-size: cover;
        background-repeat: no-repeat;
        background-attachment: scroll;
        background-color: #f8f9fa;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
      }

      .event-carousel + .carousel-caption {
      margin-top: -29px !important;
  display: block;
  border-radius: 0 0 0 0;
      }

      /* Desktop - Large screens (1024px and up) */
      @media (min-width: 1024px) {
        .event-carousel {
        width: 100%;
        height:auto;
          background-size: cover;
        }
      }

      /* Tablet - Medium screens (768px to 1023px) */
      @media (min-width: 768px) and (max-width: 1023px) {
        .event-carousel {
         width: 100%;
        height:auto;
          background-size: cover;
        }
      }

      /* Mobile - Small screens (480px to 767px) */
      @media (min-width: 480px) and (max-width: 767px) {
        .event-carousel {
       width: 100%;
        height:auto;
          background-size: cover;
          
        }
      }

      /* Mobile - Extra small screens (up to 479px) */
      @media (max-width: 479px) {
        .event-carousel {
      width: 100%;
        height:auto;
          background-size: cover;
        }
      }

      /* Very small screens (up to 360px) */
      @media (max-width: 360px) {
        .event-carousel {
       width: 100%;
        height:auto;
          background-size: contain;
        }
      }

      /* Responsive styles for captions */
      @media (max-width: 768px) {
        .event-carousel {
          aspect-ratio: auto;
          min-height: 0;
          padding-top: 56.25%;
          background-size: 100% auto;
          background-position: top center;
          align-items: stretch;
          display: block;
          overflow: hidden;
        }

        .event-slide,
        .event-slide.active {
          display: none;
          position: static;
          height: 0;
        }

        .caption-bottom {
          position: static;
          width: auto;
          min-height: 0;
          display: flex;
          flex-direction: column;
          gap: 6px;
          margin: 8px 12px 0;
        }
        
        .carousel-caption {
          position: static;
          width: auto;
          margin: 8px 12px 0;
          padding: 8px 14px;
          min-height: 0;
          border-radius: 12px;
        }
        
        .carousel-caption h2 {
          font-size: 20px !important;
          line-height: 1.1;
          margin-bottom: 0.2em;
        }
        
        .event-timer {
          font-size: 12px;
          box-shadow: 0 6px 18px rgba(0, 0, 0, 0.18);
          padding: 8px 10px;
          gap: 8px;
        }

        .event-timer div {
          min-width: 44px;
        }

        .event-timer div span {
          font-size: 1.1rem;
        }
        
        .event-cta {
          padding: 7px 12px;
          font-size: 12px;
          min-height: 34px;
        }

        .caption-content {
          position: static;
          right: auto;
          left: auto;
          bottom: 0;
          max-width: none;
          align-items: stretch;
        }

        .sponsor-btn-left {
          position: static;
          max-width: none;
          order: 2;
        }

        .sponsor-btn-left .event-cta,
        .caption-content .event-cta {
          width: 100%;
        }

        .carousel-indicators {
          position: static;
          transform: none;
          margin: 12px 0 10px;
        }
      }
      
      @media (max-width: 480px) {
        .event-carousel {
          min-height: 0;
        }

        .caption-bottom {
          min-height: 0;
          gap: 5px;
          margin: 7px 10px 0;
        }
        
        .carousel-caption {
          margin: 7px 10px 0;
          padding: 7px 12px;
          min-height: 0;
        }
        
        .carousel-caption h2 {
          font-size: 20px !important;
          line-height: 1.1;
          margin-bottom: 0.2em;
        }

        .event-meta {
          font-size: 13px;
          line-height: 1.2;
          margin-bottom: 2px;
        }
        
        .event-timer {
          font-size: 11px;
          padding: 7px 8px;
          gap: 4px;
        }

        .event-timer div {
          min-width: 38px;
        }

        .event-timer div span {
          font-size: 1rem;
        }
        
        .event-cta {
          padding: 6px 10px;
          font-size: 11px;
          min-height: 32px;
        }
        
        .caption-content {
          flex-direction: column;
          align-items: stretch;
          gap: 8px;
        }
      }
      
      @media (max-width: 360px) {
        .event-carousel {
          min-height: 0;
        }

        .caption-bottom {
          min-height: 0;
          margin: 6px 8px 0;
        }
        
        .carousel-caption {
          margin: 6px 8px 0;
          padding: 8px 10px;
          min-height: 0;
        }
        
        .carousel-caption h2 {
          font-size: 20px !important;
          line-height: 1.1;
          margin-bottom: 0.2em;
        }
        
        .event-timer {
          font-size: 12px;
        }

        .event-timer div {
          min-width: 34px;
        }
        
        .event-cta {
          padding: 5px 10px;
          font-size: 11px;
        }
      }
      `}
    </style>
    <div 
      className="event-carousel" 
      aria-label="Event media carousel"
      style={{
        backgroundImage: currentEvent?.backgroundBanner?.imageUrl 
          ? `url(${currentEvent.backgroundBanner.imageUrl})`
          : undefined,
        backgroundRepeat: 'no-repeat'
      }}
    >
      {eventsToShow.map((event, index) => (
        <article
          key={index}
          className={`event-slide ${index === currentIndex ? 'active' : ''}`}
          data-date={event.date}
          aria-live="polite"
          role="region"
        >
        </article>
      ))}

       
      
          {/*event.cta === 'Register Now' ?  <a href={`/event/${event.eventcode}`} ><button
            className="event-cta"
            aria-label={event.cta === 'Register Now' ? `Register for ${event.title}` : `${event.cta} for ${event.title}`}
          >
            {event.cta}
            
          </button></a>:null*/}

         <div className='caption-bottom'>
          {currentEvent?.eventcode === "acsc2026" && (
            <div className="sponsor-btn-left">
              <a href="/event/acsc2026/sponsors"> <button className="event-cta"> SPONSORS </button> </a>
              <a className="Agenda-btn-left" href="/event/acsc2026/schedule"> <button className="event-cta"> AGENDA </button> </a>
            </div>
          )}
           <div className="caption-content">
            <div className="event-timer" aria-label="Countdown to event" dangerouslySetInnerHTML={{ __html: timers[currentIndex] || '' }}/>
          </div>
          {currentEvent?.cta === 'Register Now' ? (
            <div className="register-btn-left">
              <a href={`/event/${currentEvent?.eventcode}`}>
              <button className="event-cta">
                {currentEvent?.cta}
              </button>
              </a>
            </div>
          ) : null}
          {currentEvent?.eventcode === "atp2026" && (
            <div className="agenda-btn-atp">
              <a href="/event/atp2026/schedule">
              <button className="event-cta">
                TRAININGS AGENDA
              </button>
              </a>
              </div>
            )}
          </div>

          <div className="carousel-indicators" role="tablist" aria-label="Select Event Slide">
        {eventsToShow.map((_, index) => (
          <button
            key={index}
            aria-label={`${eventsToShow[index].title} Slide`}
            className={index === currentIndex ? 'active' : ''}
            onClick={() => handleIndicatorClick(index)}
            role="tab"
          />
        ))}
      </div>
    </div>
    
    <div className='carousel-caption'>
      <div>
        <h2>{currentEvent?.title}</h2>
        <div className="event-meta">{currentEvent?.meta}</div>
        {currentEvent?.cta === 'Registrations Closed' ? <p className="status-text status-closed" >Registrations Closed.</p> :null}
        {currentEvent?.cta === 'Coming Soon' ? <p className="status-text status-coming-soon" >Registrations coming soon !!!</p> :null}
      </div>
    </div>
      
  </>
  );
};

export default EventCarousel;
